var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"border w-[120px] text-sm text-black px-2 py-1 rounded-[2px] bg-white cursor-pointer ml-[120px]"},_vm.handlers),[_vm._v(" "+_vm._s(_vm.displayText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }